import Hero from "../components/home/Hero";
import BrandMarquee from "../components/home/BrandMarquee";
import WhyChoose from "../components/home/WhyChoose";
import FeaturedServices from "../components/home/FeaturedServices";
import PackagesPreview from "../components/home/PackagesPreview";
import PortfolioPreview from "../components/home/PortfolioPreview";
import Testimonials from "../components/home/Testimonials";
import FinalCTA from "../components/home/FinalCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <BrandMarquee />
      <WhyChoose />
      <FeaturedServices />
      <PackagesPreview />
      <PortfolioPreview />
      <Testimonials />
      <FinalCTA />
    </div>
  );
}
